import React from 'react';
import withIcon from '../utilities/withIcon';

const IconCopyright = () => {
  return (
    <g>
      <path d="m8 .03a7.97 7.97 0 1 0 7.97 7.97 7.9787 7.9787 0 0 0 -7.97-7.97zm0 14.44a6.47 6.47 0 1 1 6.47-6.47 6.4773 6.4773 0 0 1 -6.47 6.47z" />
      <path d="m9.8665 6.1333a.75.75 0 1 0 1.0605-1.0605 4.14 4.14 0 1 0 0 5.8535.75.75 0 1 0 -1.0605-1.0606 2.7 2.7 0 0 1 -3.7329 0 2.6394 2.6394 0 1 1 3.7329-3.7324z" />
    </g>
  );
};

export default withIcon(IconCopyright);
